import './map.css';
import {useCallback, useEffect, useState} from "react";
import {GoogleMap, useJsApiLoader} from "@react-google-maps/api";

const ReactMap = (
    {
        height = '100%',
        center = {
            lat: 13.028753,
            lng: 77.584400
        },
        zoom = 16,
        children,
        onclick,
        panToLatLng,
        fitBound = []
    }
) => {
    // .... default options .....
    const OPTIONS = {
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
        styles: [
            {
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f0f0f0"
                    }
                ]
            },
            {
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#b9b9b9"
                    }
                ]
            },
            {
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "color": "#f7f7f7"
                    }
                ]
            },
            {
                "featureType": "administrative.land_parcel",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#bdbdbd"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#d7d7d7"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#757575"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#dcdcdc"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#9e9e9e"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#ffffff"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#757575"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#dadada"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#616161"
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#9e9e9e"
                    }
                ]
            },
            {
                "featureType": "transit.line",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#e5e5e5"
                    }
                ]
            },
            {
                "featureType": "transit.station",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#eeeeee"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#c9c9c9"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#9e9e9e"
                    }
                ]
            }
        ],
    }
    const containerStyle = {
        width: '100%',
        height: '100%'
    };
    const [map, setMap] = useState(null);

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: "AIzaSyCyqGWfLjwQjvkmSoyS98ptW3fIrG_Ytio"
    })
    const onLoad = useCallback(function callback(map) {
        // This is just an example of getting and using the map instance!!! don't just blindly copy!
        setMap(map);
    }, [])
    const onUnmount = useCallback(function callback(map) {
        setMap(null)
    }, [])

    useEffect(() => {
        if (panToLatLng?.lat && panToLatLng?.lng) {
            map.panTo(panToLatLng);
        }
    }, [panToLatLng])

    useEffect(() => {
        let bounds = null;
        if (map && fitBound.length > 0) {
            bounds = new window.google.maps.LatLngBounds();
            for (var i = 0; i < fitBound.length; i++) {
                bounds.extend(new window.google.maps.LatLng(fitBound[i]?.lat, fitBound[i]?.lng));
            }
            map.fitBounds(bounds, 20);
        }
    }, [fitBound])

    return (
        isLoaded ? (
            <>
                {/*<button className={'btn'} onClick={AddMarkers}>Add Markers</button>*/}
                <GoogleMap
                    options = {OPTIONS}
                    mapContainerStyle={containerStyle}
                    center={center}
                    zoom={zoom}
                    onLoad={onLoad}
                    onClick={onclick}
                    onUnmount={onUnmount}>
                    {
                        children
                    }
                </GoogleMap>
            </>
        ) : <>
        <div className="">Not loaded</div>
        </>
    )
}

export default ReactMap;
